import { EventRow, EventStatus as EventStatusType } from "@opengov/stories-shared/types";
import { SHARED_TIMELINE_CHART_CONFIG, EVENT_STATUS_OPTIONS, getStatusColor } from "@opengov/stories-shared/constants/timelineChart";

export const PROGRESS_TRACKER_MODES = {
	READ_ONLY: 'readOnly',
	EDIT_WITH_CONFIG: 'editWithConfig',
};

export const MAX_EVENTS = 12;
export const MIN_EVENTS = 2;

export type ProgressTrackerMode = typeof PROGRESS_TRACKER_MODES[keyof typeof PROGRESS_TRACKER_MODES];

export { EVENT_STATUS_OPTIONS, EventStatusType, getStatusColor };

export const defaultEvents: EventRow[] = [
	{
		id: '1',
		title: '',
		description: '',
		status: {
			id: '1',
			title: 'Not Started'
		}
	},
	{
		id: '2',
		title: '',
		description: '',
		status: {
			id: '1',
			title: 'Not Started'
		}
	},
	{
		id: '3',
		title: '',
		description: '',
		status: {
			id: '1',
			title: 'Not Started'
		}
	}
];

export { SHARED_TIMELINE_CHART_CONFIG };

export const TIMELINE_CHART_OPTIONS = {
	...SHARED_TIMELINE_CHART_CONFIG,
	title: {
		text: ''
	},
	series: [{
		...SHARED_TIMELINE_CHART_CONFIG.series[0],
		data: []
	}]
};